import React from 'react';

/**
 * Left-edge drag handle for the docked output / chat column.
 */
const OutputPanelResizeHandle = ({ onResizeStart, disabled = false }) => (
  <div
    role="separator"
    aria-orientation="vertical"
    aria-label="Resize output panel. Drag left to widen, right to narrow."
    onMouseDown={disabled ? undefined : onResizeStart}
    className={`absolute left-0 top-0 bottom-0 z-20 hidden w-2 md:block ${
      disabled ? 'pointer-events-none' : 'cursor-col-resize'
    } group`}
  >
    <div
      className={`absolute inset-y-3 left-0 w-px transition-colors ${
        disabled
          ? 'bg-transparent'
          : 'bg-slate-200 group-hover:bg-amber-400 group-active:bg-amber-500'
      }`}
    />
  </div>
);

export default OutputPanelResizeHandle;
